if (!window.SubcolCarousel) {
  window.SubcolCarousel = class {
    constructor(el) {
      this.el = el;
      this.id = el.dataset.carousel;
      this.track = el.querySelector('.carousel-track');
      this.viewport = el.querySelector('.carousel-viewport');
      this.prevBtn = el.querySelector('[data-dir="prev"]');
      this.nextBtn = el.querySelector('[data-dir="next"]');
      this.total = parseInt(el.dataset.total);
      this.desktopCols = parseInt(el.dataset.desktopColumns);
      this.mobileCols = parseInt(el.dataset.mobileColumns);
      this.currentIndex = 0;
      this.isInitialized = false;
      this.cachedItemWidth = null;
      this.cachedGap = null;
      this.resizeTimer = null; 
      this.boundHandleResize = this.handleResize.bind(this); 
      requestAnimationFrame(() => this.init());
    }
    
    init() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.cacheLayoutMeasurements();
      this.updateView();
      this.bindEvents();
    }
    
    cacheLayoutMeasurements() {
      if (this.track && this.track.children[0]) {
        this.cachedItemWidth = this.track.children[0].offsetWidth;
        this.cachedGap = parseInt(getComputedStyle(this.track).gap) || 0;
      }
    }
    
    get visibleItems() {
      return window.innerWidth >= 750 ? this.desktopCols : this.mobileCols;
    }
    
    get maxIndex() {
      return Math.max(0, this.total - this.visibleItems);
    }
    
    updateView() {
      if (!this.track || !this.cachedItemWidth) return; 
      const offset = this.currentIndex * (this.cachedItemWidth + this.cachedGap);
      this.track.style.transform = `translateX(-${offset}px)`;
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    }
    
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateView();
      }
    }
    
    next() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
        this.updateView();
      }
    }
    
    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.cacheLayoutMeasurements();
        this.updateView();
      }, 150);
    }
    
    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }
      
      let startX = 0;
      let isDragging = false;
      
      const handleStart = (e) => {
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        isDragging = true;
      };
      
      const handleEnd = (e) => {
        if (!isDragging) return;
        const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        const diff = startX - endX;
        
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.next() : this.prev();
        }
        isDragging = false;
      };
      
      this.viewport.addEventListener('touchstart', handleStart, { passive: true });
      this.viewport.addEventListener('touchend', handleEnd, { passive: true });
      this.viewport.addEventListener('mousedown', handleStart);
      this.viewport.addEventListener('mouseup', handleEnd);
      this.viewport.addEventListener('mouseleave', () => { isDragging = false; });
      
      window.addEventListener('resize', this.boundHandleResize);
    }
    
    destroy() {
      window.removeEventListener('resize', this.boundHandleResize);
      clearTimeout(this.resizeTimer);
      this.isInitialized = false;
    }
  };

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(el => {
      if (!el.dataset.initialized) {
        const instance = new SubcolCarousel(el);
        el.__instance = instance;
        el.dataset.initialized = 'true';
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
  
  document.addEventListener('shopify:section:load', initCarousels);
  document.addEventListener('shopify:section:unload', (e) => {
    const carousel = e.target.querySelector('[data-carousel]');
    if (carousel && carousel.__instance) {
      carousel.__instance.destroy();
      delete carousel.__instance;
      delete carousel.dataset.initialized;
    }
  });
}